import React from "react";
import FetchHelper from "./lib/fetchHelper.js";
import ConfirmDialog from "./lib/confirmDialog";
export default class MarkForExchangeComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirm: false,
            busy: false,
            error: null
        };
    }
    askConfirm() {
        this.setState({ confirm: true, error: null });
    }
    cancelConfirm() {
        this.setState({ confirm: false });
    }
    /**
     * Raw fetch rather than FetchHelper.post: a refusal's reason comes back as the body, and the
     * helper rejects with the status line alone. This used to have neither - no catch at all - so
     * a volunteer pressing "Udbyd vagt" on a shift already on the exchange, or one they had since
     * been taken off, was left looking at "Bekræft?" with nothing having happened.
     *
     * A refusal drops out of the confirm state so the button is there to read the reason against,
     * rather than an offer to confirm something that has just been turned down.
     */
    markForExchange() {
        const failure = "Vagten kunne ikke udbydes";
        this.setState({ busy: true });
        fetch(`/bpapi/shiftexchange/mark`, FetchHelper.postOptions({ shiftId: this.props.shiftid }))
            .then((response) => response.ok
            ? response.json().then((result) => this.props.onsuccess(result))
            : response.text().then((body) => this.setState({
                confirm: false,
                busy: false,
                error: body || failure
            })))
            .catch(() => this.setState({ confirm: false, busy: false, error: failure }));
    }
    render() {
        return (React.createElement(React.Fragment, null,
            this.state.error
                ? React.createElement("div", { className: "alert alert-danger p-2 small" }, this.state.error)
                : null,
            (this.state.confirm) ? this.confirmState() : this.defaultState()));
    }
    /**
     * The board's "Udbyd vagt - bekræft": a dialog over the page that names the shift being put on the
     * exchange - the day and time, the role and the films - before asking. The yes is green, since
     * it is the positive answer.
     */
    confirmState() {
        return (React.createElement(React.Fragment, null,
            this.defaultState(),
            React.createElement(ConfirmDialog, { heading: "S\u00E6t vagten til bytte", title: this.props.when, subtitle: this.props.detail, message: "Bekr\u00E6ft?", positive: true, busy: this.state.busy, onYes: () => this.markForExchange(), onNo: () => this.cancelConfirm() })));
    }
    defaultState() {
        // On Vagtinfo the button is the large outlined "Sæt vagten til bytte".
        if (this.props.variant === "vagtinfo") {
            return (React.createElement("button", { type: "button", className: "bi-btn bi-btn-outline bi-btn-large", onClick: () => this.askConfirm() },
                React.createElement("svg", { viewBox: "0 0 24 24", width: "18", height: "18", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
                    React.createElement("path", { d: "M7 4 3 8l4 4M3 8h14M17 12l4 4-4 4M21 16H7" })),
                "S\u00E6t vagten til bytte"));
        }
        // On the front page the button is the board's outlined "Sæt til bytte".
        if (this.props.variant === "front") {
            return (React.createElement("button", { type: "button", className: "bi-btn bi-btn-outline", onClick: () => this.askConfirm() }, "S\u00E6t til bytte"));
        }
        return (React.createElement("div", { className: "d-grid" },
            React.createElement("button", { className: "btn btn-primary btn-sm", onClick: () => this.askConfirm() },
                React.createElement("span", null,
                    React.createElement("i", { className: "far fa-life-ring" }),
                    "Udbyd vagt"))));
    }
}
